// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow_target_binding.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ConnectorRef } from "../../app/v1/connector";
import { Any } from "../../../../google/protobuf/any";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask
 */
export interface PasswordPushFlowTargetBindingExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingRef
 */
export interface PasswordPushFlowTargetBindingRef {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBinding
 */
export interface PasswordPushFlowTargetBinding {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
    /**
     * @generated from protobuf field: string connector_path = 5
     */
    connectorPath: string;
}
// ====== List ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListRequest
 */
export interface PasswordPushFlowTargetBindingServiceListRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask = 2
     */
    expandMask?: PasswordPushFlowTargetBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListResponse
 */
export interface PasswordPushFlowTargetBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list = 1
     */
    list: PasswordPushFlowTargetBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
// ====== Mutate ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateRequest
 */
export interface PasswordPushFlowTargetBindingServiceMutateRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorRef refs = 2
     */
    refs: ConnectorRef[];
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask = 4
     */
    expandMask?: PasswordPushFlowTargetBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateResponse
 */
export interface PasswordPushFlowTargetBindingServiceMutateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list = 1
     */
    list: PasswordPushFlowTargetBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
// ====== Delete ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteRequest
 */
export interface PasswordPushFlowTargetBindingServiceDeleteRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteResponse
 */
export interface PasswordPushFlowTargetBindingServiceDeleteResponse {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingExpandMask$Type extends MessageType<PasswordPushFlowTargetBindingExpandMask> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "connector_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingExpandMask>): PasswordPushFlowTargetBindingExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingExpandMask): PasswordPushFlowTargetBindingExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask
 */
export const PasswordPushFlowTargetBindingExpandMask = new PasswordPushFlowTargetBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingRef$Type extends MessageType<PasswordPushFlowTargetBindingRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingRef", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingRef>): PasswordPushFlowTargetBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushFlowId = "";
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingRef): PasswordPushFlowTargetBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_flow_id */ 1:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_flow_id = 1; */
        if (message.passwordPushFlowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingRef
 */
export const PasswordPushFlowTargetBindingRef = new PasswordPushFlowTargetBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBinding$Type extends MessageType<PasswordPushFlowTargetBinding> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBinding", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBinding>): PasswordPushFlowTargetBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushFlowId = "";
        message.appId = "";
        message.connectorId = "";
        message.appPath = "";
        message.connectorPath = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBinding): PasswordPushFlowTargetBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_flow_id */ 1:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                case /* string connector_path */ 5:
                    message.connectorPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_flow_id = 1; */
        if (message.passwordPushFlowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        /* string connector_path = 5; */
        if (message.connectorPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.connectorPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBinding
 */
export const PasswordPushFlowTargetBinding = new PasswordPushFlowTargetBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceListRequest$Type extends MessageType<PasswordPushFlowTargetBindingServiceListRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => PasswordPushFlowTargetBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingServiceListRequest>): PasswordPushFlowTargetBindingServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushFlowId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingServiceListRequest): PasswordPushFlowTargetBindingServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_flow_id */ 1:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask */ 2:
                    message.expandMask = PasswordPushFlowTargetBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_flow_id = 1; */
        if (message.passwordPushFlowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask = 2; */
        if (message.expandMask)
            PasswordPushFlowTargetBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListRequest
 */
export const PasswordPushFlowTargetBindingServiceListRequest = new PasswordPushFlowTargetBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceListResponse$Type extends MessageType<PasswordPushFlowTargetBindingServiceListResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlowTargetBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingServiceListResponse>): PasswordPushFlowTargetBindingServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingServiceListResponse): PasswordPushFlowTargetBindingServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list */ 1:
                    message.list.push(PasswordPushFlowTargetBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPushFlowTargetBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListResponse
 */
export const PasswordPushFlowTargetBindingServiceListResponse = new PasswordPushFlowTargetBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceMutateRequest$Type extends MessageType<PasswordPushFlowTargetBindingServiceMutateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => PasswordPushFlowTargetBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingServiceMutateRequest>): PasswordPushFlowTargetBindingServiceMutateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushFlowId = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingServiceMutateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingServiceMutateRequest): PasswordPushFlowTargetBindingServiceMutateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_flow_id */ 1:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.ConnectorRef refs */ 2:
                    message.refs.push(ConnectorRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask */ 4:
                    message.expandMask = PasswordPushFlowTargetBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingServiceMutateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_flow_id = 1; */
        if (message.passwordPushFlowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* repeated c1.api.app.v1.ConnectorRef refs = 2; */
        for (let i = 0; i < message.refs.length; i++)
            ConnectorRef.internalBinaryWrite(message.refs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask = 4; */
        if (message.expandMask)
            PasswordPushFlowTargetBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateRequest
 */
export const PasswordPushFlowTargetBindingServiceMutateRequest = new PasswordPushFlowTargetBindingServiceMutateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceMutateResponse$Type extends MessageType<PasswordPushFlowTargetBindingServiceMutateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlowTargetBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingServiceMutateResponse>): PasswordPushFlowTargetBindingServiceMutateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingServiceMutateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingServiceMutateResponse): PasswordPushFlowTargetBindingServiceMutateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list */ 1:
                    message.list.push(PasswordPushFlowTargetBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingServiceMutateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPushFlowTargetBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateResponse
 */
export const PasswordPushFlowTargetBindingServiceMutateResponse = new PasswordPushFlowTargetBindingServiceMutateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceDeleteRequest$Type extends MessageType<PasswordPushFlowTargetBindingServiceDeleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingServiceDeleteRequest>): PasswordPushFlowTargetBindingServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushFlowId = "";
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingServiceDeleteRequest): PasswordPushFlowTargetBindingServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_flow_id */ 1:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_flow_id = 1; */
        if (message.passwordPushFlowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteRequest
 */
export const PasswordPushFlowTargetBindingServiceDeleteRequest = new PasswordPushFlowTargetBindingServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceDeleteResponse$Type extends MessageType<PasswordPushFlowTargetBindingServiceDeleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteResponse", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowTargetBindingServiceDeleteResponse>): PasswordPushFlowTargetBindingServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushFlowId = "";
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowTargetBindingServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowTargetBindingServiceDeleteResponse): PasswordPushFlowTargetBindingServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_flow_id */ 1:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowTargetBindingServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_flow_id = 1; */
        if (message.passwordPushFlowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteResponse
 */
export const PasswordPushFlowTargetBindingServiceDeleteResponse = new PasswordPushFlowTargetBindingServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowTargetBindingService
 */
export const PasswordPushFlowTargetBindingService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowTargetBindingService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowTargetBindingServiceListRequest, O: PasswordPushFlowTargetBindingServiceListResponse },
    { name: "Mutate", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowTargetBindingServiceMutateRequest, O: PasswordPushFlowTargetBindingServiceMutateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowTargetBindingServiceDeleteRequest, O: PasswordPushFlowTargetBindingServiceDeleteResponse }
]);
